<template>
  <div id="generateSaleModal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Gerar venda do grupo</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mb-4">
            <div class="col-md-12">
              <label>Referente ao mês</label>
              <SelectInvoiceBillingMonth
                :first="'Mês do faturamento'"
                @change="setBillingMonth($event)"
                class="mr-2"
                v-b-tooltip.hover
                title="Selecione o mês de faturamento"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-metal m-btn m-btn--outline"
            style="font-weight:600; float:right;"
            data-dismiss="modal"
          >
            Fechar
          </button>
          <button
            type="submit"
            :disabled="!data.billingMonth || !data.groupId"
            @click="sendGenerate()"
            class="btn btn-sm btn-focus"
            style="font-weight:600;"
          >
            Gerar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';
import axios from 'axios';
import { baseApiUrl } from '@/global';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

export default {
  name: 'GenerateSalePerGroup',
  mixins: [returnMessageMixin],
  components: { SelectInvoiceBillingMonth },
  data() {
    return {
      data: {
        groupId: '',
        billingMonth: '',
      },
    };
  },
  methods: {
    setBillingMonth(value) {
      this.data.billingMonth = value;
    },
    setGroup(value) {
      this.data.groupId = value;
    },
    sendGenerate() {
      const url = `${baseApiUrl}/v1/invoice/generate-sale-group`;
      axios
        .post(url, this.data)
        .then((res) => {
          this.logMessage(res);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
};
</script>

<style></style>
